import api from '@/services/api';
import type { FundingPurpose, InvoiceLinePayload } from '../types/agreements.types';

export const checkFundingApprovalCode = async (
    agreementId: string,
    approvalId: string,
    purpose: FundingPurpose,
    lines: InvoiceLinePayload[],
    code: string,
): Promise<void> => {
    await api.post(`/invoicing/agreements/${agreementId}/funding-approvals/${approvalId}/check`, { purpose, lines, code });
};
